export default class DrawerBloc {
  constructor({ drawerRepository }) {
    this.drawerRepository = drawerRepository;
  }

  get drawerDetails$() {
    return this.drawerRepository.drawerDetails$;
  }

  toggleDrawer(open) {
    this.drawerRepository.toggleDrawer(open);
  }
}
